import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { MAIN_ROUTES } from 'common/config/routes.config';
import { Footer } from 'common/components';
import { RootState } from 'common/redux/core/root.reducer';
import { getUserName } from 'common/redux/user/user.selector';

import Home from 'modules/home/pages/home/Home';

import './NewUserLayout.scss';

const NewUserLayout: FC = () => {
    const userName = useSelector((state: RootState) => getUserName(state));
    return (
        <div className="auth-layout-container">
            <div className="auth-layout-main">
                <div className="auth-layout-content">
                    <Routes>
                        <Route
                            path={MAIN_ROUTES.HOME}
                            element={<Home userName={userName} hasAccess={false} />}
                        />
                        <Route
                            path={MAIN_ROUTES.DEFAULT}
                            element={<Navigate to={MAIN_ROUTES.HOME} />}
                        />
                        <Route
                            path={MAIN_ROUTES.WILD}
                            element={<Navigate to={MAIN_ROUTES.HOME} />}
                        />
                    </Routes>
                </div>
            </div>
            <div>
                <Footer />
            </div>
        </div>
    );
};

export default NewUserLayout;
